import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MainLayout from '../layouts/MainLayout';
import { RSMIN_APP_URL } from '../config';

const LoginPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    }
  };

  const rsminCallbackUrl = `${window.location.origin}/auth/rsmin-callback`;
  const rsminLoginUrl = RSMIN_APP_URL
    ? `${RSMIN_APP_URL.replace(/\/$/, '')}/auth/redirect-to-cip?redirectUri=${encodeURIComponent(rsminCallbackUrl)}`
    : '';

  const handleRSMinLogin = () => {
    window.location.href = rsminLoginUrl;
  };

  return (
    <MainLayout>
      <div className="page auth-page">
        <h2>Login</h2>
        {error && <div className="error-msg">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required />
          <input name="password" type="password" placeholder="Password" value={form.password} onChange={handleChange} required />
          <button type="submit">Login</button>
        </form>
        {rsminLoginUrl && (
          <>
            <p>or</p>
            <button type="button" onClick={handleRSMinLogin}>Login with RSMin</button>
          </>
        )}
        <p>Don't have an account? <Link to="/register">Register</Link></p>
      </div>
    </MainLayout>
  );
};

export default LoginPage;
